import client from '../client'

export const getCommunicationPreferencesKey = `${process.env.NEXT_PUBLIC_NOTIFICATIONS_DOMAIN}/api/UserAccounts/GetCommunicationPreference`

export async function getCommunicationPreferences() {
  return client(getCommunicationPreferencesKey)
}
